var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-box-container" },
    [
      [
        _c(
          "div",
          {
            staticClass: "d-flex list-box-header col-12 pointer",
            on: {
              click: function($event) {
                _vm.$emit("editServer")
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "pl-0 list-box-header-left col-lg-9 col-12 pr-3" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pl-0 d-flex align-items-center col-lg-4 col-12"
                  },
                  [
                    _c("div", { staticClass: "claim-customer col-12 wrap" }, [
                      _c("span", { staticClass: "full-name" }, [
                        _vm._v(_vm._s(_vm.server.mail_username))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center col-lg-8 col-12" },
                  _vm._l(_vm.companies, function(company) {
                    return _c("span", { key: company.id }, [
                      company.id === _vm.server.company_id
                        ? _c("span", [_vm._v(_vm._s(company.name))])
                        : _vm._e()
                    ])
                  })
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-box-header-right col-lg-3 col-12 pl-4" },
              [
                _c("label"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center col-12 mail-host" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.server.mail_host) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1330f3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1330f3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Mailing/SmtpServersBlock.vue
// module id = null
// module chunks = 